import type { ActionFlowNode, FlowNodeResultADT, SendEmailActionConfigure } from '@lighthouse/shared'
import { generateHtmlBySendEmail, generateVariableValue, getEmails } from '@lighthouse/shared'
import { safeToString } from '@lighthouse/tools'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleSendEmail = async (
    node: ActionFlowNode<SendEmailActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    const {
        data: { config }
    } = node
    const { recipients, cc, title, enableCc, senderAccountType } = config

    if (!config) {
        throw new Error(t('configurationNotPerfect'))
    }
    const titleValue = generateVariableValue({
        innerType: 'TEXT',
        jsonContent: title,
        extraParams: params,
        options: { format: true, useFileUrl: true }
    })

    const html = generateHtmlBySendEmail({
        config,
        excParams: params
    })

    const recipientsValue = getEmails(recipients, params)
    const ccValue = enableCc ? getEmails(cc, params) : []

    const isSuccess = await srv.activeSendEmailAction({
        senderAccountType,
        recipients: recipientsValue,
        cc: ccValue,
        title: safeToString(titleValue),
        content: html
    })

    return {
        type: 'record',
        success: isSuccess
    }
}
